export default __webpack_public_path__ + "static/media/token-5.ee419590.png";